<template>
  <div class="floor1-wrapper">
    <div class="content">
      <div class="floor-title w1">
        <img src="https://img.gegejia.com/img/3c78c952be577950b58dee498e1aca8f.png" alt>
        <img src="https://img.gegejia.com/img/21c8ab597c9ae73de6ebc9b46a254d28.png" class="ma" alt="">
      </div>
      <div class="floor-title w2">
        <img src="https://img.gegejia.com/img/9e09061328563d5c4330b1f42439edff.png" alt>
        <img src="https://img.gegejia.com/img/fb74fbbdac25f9c148471f71efc5e21a.png" class="ma" alt="">
      </div>
    </div>
    <video class="video" autoplay="autoplay" :muted="muteStatus" loop>
      <source src="https://cdn.gegejia.com/mp4/T97_home.mp4" type="video/mp4">
    </video>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bigCodeVisible: false,
      muteStatus: 'muted',
      isMute:false,
      appStoreVisible: false,
      andriodVisible: false,
    };
  },
  methods: {
    appStoreEnter() {
      this.appStoreVisible = true;
    },
    appStoreLeave() {
      this.appStoreVisible = false;
    },
    andriodEnter() {
      this.andriodVisible = true;
    },
    andriodLeave() {
      this.andriodVisible = false;
    },
    enter() {
      this.bigCodeVisible = true;
    },
    leave() {
      this.bigCodeVisible = false;
    },
    muteStatusCtrl (){
      this.isMute = !this.isMute;
      if(this.isMute){
          this.muteStatus = '';
      }else{
          this.muteStatus = 'muted';
      }
    },
    toAppStore(){
      location.href = "https://itunes.apple.com/cn/app/id1441491837"
    },
    toAndroidStore(){
      location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.banma"
    }
  }
};
</script>

<style scoped lang="less">
.floor1-wrapper{
  width: 100%;
  /*height: calc(~'100% - 106px');*/
  /*height: 100%;*/
  min-width: 1200px;
  position: relative;
  background-color: #000;
  opacity:0.8;
  .video{
    /*position: absolute;*/
    /*z-index: -999;*/
    width: 100%;
    /*height: 100%;*/
  }
  .content{
    position: absolute;
    right: 7.5%;
    bottom: 138px;
    display: flex;
    z-index: 100;
    .w1{
      img{
        width: 271px;
        height: 63px;
      }
    }
    .w2{
      margin-left:14px;
      img{
        width: 217px;
        height: 63px;
      }
    }
    .floor-title{
      position: relative;
      cursor: pointer;
      .ma{
        opacity: 0;
        transition: 0.2s ease all;
        position: absolute;
        left:22%;
        bottom:80px;
        width: 157px;
        height: 164px;
      }
    }
    .w2 .ma{
      left:13%;
    }
    .floor-title:hover{
      .ma{
        opacity: 1;
      }

    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/t97/block/floor_1.vue